class AppConstants {
    static drawerWidth = 250;
    static JWT = "JWT";
    static FCM = "FCM";
    static business_id = "business_id";
    static name = "name";
}
export default AppConstants;
